import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SettingsHistoryResult } from 'src/app/core/settingsHistory/settingsHistory.service';
import { SettingValuePipe } from '../../setting-value.pipe';

@Component({
  selector: 'history-cell',
  template: `<span>{{settingHistoryValue}}</span><span class="deviceAccepted" *ngIf="this.deviceAccepted">(Device Accepted)</span>`,
  styleUrls: ['./history-cell.component.scss']
})
export class HistoryCellComponent implements ICellRendererAngularComp {
  settingHistoryValue: string;
  clickable: boolean = false;
  deviceAccepted: boolean = false;

  constructor(private settingValuePipe: SettingValuePipe) { }

  agInit(params: any): void {
    this.deviceAccepted = params.data.isLastKnown;
    this.settingHistoryValue = this.settingValuePipe.getDisplayedSettingValue(params.data.settingName, params.value);
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }
}
